<template>
  <van-popup
    v-model="localValue"
    get-container="body"
    :class="_.dialog"
    lazy-render
    close-on-click-overlay
    close-on-popstate
    @click-overlay="handleMaskClick"
  >
    <div :class="_.title">验证手机号</div>
    <div :class="_.desc">若您未注册过多彩宝，验证手机后将为您自动注册</div>
    <label :class="[_.field, _._hairlineBottom]">
      <input
        v-model="phoneNumber"
        v-fix-keyboard
        type="tel"
        :class="_.input"
        placeholder="请输入您的手机号"
      />
    </label>
    <label :class="[_.field, _._hairlineBottom]">
      <input
        v-model="vcode"
        v-fix-keyboard
        :class="_.input"
        placeholder="输入验证码"
      />
      <div
        :class="[_.action, !!time && _.disabled]"
        @click.prevent.stop="handleSendClick"
      >
        {{ time ? `${time}s重试` : '发送验证码' }}
      </div>
    </label>
    <div
      :class="[_.button, (!phoneNumber || !vcode) && _.disabled]"
      @click="handleLoginClick"
    >
      登录
    </div>
  </van-popup>
</template>

<script>
  import Messenger from 'vue-messenger'
  import Vue from 'vue'
  import { yup as _ } from 'vtils/validator'
  import { apiUserLoginH5LoginBySms, apiUserLoginH5SendSms4 } from '@/api'
  import { globalModel } from '@/model'
  import { last } from 'vtils'
  import { navigateBack } from '@/router'
  import { submit } from '@/utils'

  const rules = _.object({
    phoneNumber: _.string()
      .required('请输入您的手机号')
      .chineseMobilePhoneNumber('手机号输入不正确，请重新输入'),
    vcode: _.string().required('请输入验证码'),
  })

  export default Vue.extend({
    mixins: [Messenger],

    props: {
      value: {
        type: Boolean,
        required: true,
      },
    },

    data: () => ({
      phoneNumber: '',
      vcode: '',
      time: 0,
    }),

    methods: {
      handleMaskClick() {
        const currentRoute = this.$route
        const matched = currentRoute.matched
        const currentPage = last(matched)
        const currentPageInstance = currentPage.instances.default
        const loading =
          currentPageInstance.loading ??
          currentPageInstance.$children[0]?.loading ??
          false
        if (loading) {
          navigateBack()
        }
        this.$emit('cancel')
      },
      handleSendClick() {
        submit(async $ => {
          const { data, error } = rules.validatePlusSync({
            phoneNumber: this.phoneNumber,
          })
          if (error) {
            return $.fail(error.message)
          }
          await $.start('发送中...')
          await apiUserLoginH5SendSms4(
            {
              phone: data.phoneNumber,
            },
            {
              noP: true,
            },
          )
          this.time = 60
          const timer = setInterval(() => {
            this.time--
            if (this.time === 0) {
              clearInterval(timer)
            }
          }, 1000)
          await $.success('发送成功')
        })
      },
      handleLoginClick() {
        submit(async $ => {
          const { data, error } = rules.validatePlusSync({
            phoneNumber: this.phoneNumber,
            vcode: this.vcode,
          })
          if (error) {
            return $.fail(error.message)
          }
          await $.start('登录中...')
          const { p } = await apiUserLoginH5LoginBySms(
            {
              platform: 'h5Mall',
              phone: data.phoneNumber,
              verification: data.vcode,
              openId: globalModel.state.openid,
            },
            {
              noP: true,
            },
          )
          await $.success('登录成功')
          this.localValue = false
          this.$emit('success', p)
        })
      },
    },
  })
</script>

<style lang="scss" module>
  .dialog {
    width: 351px;
    background: #ffffff;
    border-radius: 8px;
    box-sizing: border-box;
    padding: 24px 24px 36px 24px;

    // 应设为 false，不然如果 loading 状态下需要微信弹窗登录，其添加的 css 会导致弹窗不可点击
    * {
      pointer-events: auto;
    }

    .title {
      font-size: 26px;
      font-weight: bold;
      color: #1b1f1f;
      line-height: 37px;
    }

    .desc {
      margin-top: 4px;
      margin-bottom: 12px;
      font-size: 12px;
      color: #babbbb;
      line-height: 17px;
    }

    .field {
      margin-top: 12px;
      display: flex;
      align-items: center;

      .input {
        flex-grow: 1;
        appearance: none;
        outline: none;
        border: none;
        border-radius: 0;
        box-shadow: none;
        font-size: 16px;
        padding: 12px 0;

        &::placeholder {
          color: #d1d2d2;
        }
      }

      .action {
        flex-shrink: 0;
        font-size: 16px;
        font-weight: bold;
        color: #ff960a;

        &:active {
          opacity: 0.9;
        }

        &.disabled {
          pointer-events: none;
        }
      }
    }

    .button {
      margin-top: 24px;
      height: 50px;
      background: #ff960a;
      border-radius: 25px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 16px;
      font-weight: bold;
      color: #ffffff;

      &:active {
        filter: contrast(0.9);
      }

      &.disabled {
        pointer-events: none;
        background-color: #e9e9e9;
      }
    }
  }
</style>
